var Model = require("../types/Model.js");

module.exports = new Model({
	name: "machineindex",
	init: init,
	uninit: uninit,
	listeners: listeners,

	_machines: null,
	_serial: null,

	recalculate: recalculate,
});

function init() {
	this.push(0);
}

function uninit() {
	this._machines = null;
	this._serial = null;
}

function listeners() {
	return {
		"groupmachines:updated": handleMachinesUpdated,
		"machinetracker:updated": handleMachineTrackerUpdated,
	};
}

function recalculate() {
	if (!this._machines) return;
	if (!this._serial) return;
	if (!this._machines.length);

	var position = Object.keys(this._machines).sort().indexOf(this._serial);
	if (position === -1) return;

	var index = (position) % 4 + 1;

	if (index === this.data) return;

	this.push(index);
}

function handleMachinesUpdated(machines) {
	this._machines = machines;

	this.recalculate();
}

function handleMachineTrackerUpdated(tracker) {
	this._serial = tracker.serial;

	this.recalculate();
}
